import { logoutWtApp } from "../androidAndIosApp";
import { isAppTypeIframe } from "../getAppType";
import { useSettings } from "../settings/useSettings";
import { useWhoAmI } from "../user/useWhoAmI";
import { getRedirectProps, redirect } from "./redirect";

export const useLogOut = () => {
  const settings = useSettings();
  const { whoAmI } = useWhoAmI();

  return () => {
    if (window.iswtapp) {
      logoutWtApp();
    }

    let params = new URLSearchParams();

    if (window.cvpIdConcern) {
      params.append("k", window.cvpIdConcern.toString());
    }

    let urlToGoToAfterLogout = isAppTypeIframe() ? settings.iframe_startPage : "/";

    const logoutRedirectUrl = getRedirectProps(urlToGoToAfterLogout!, {
      mergeQs: {
        k: window.cvpIdConcern ?? null,
      },
    }).href!;

    const searchParams = new URLSearchParams();
    searchParams.set("logoutRedirectUrl", logoutRedirectUrl);
    const qs = searchParams.toString();

    function getLogoutPath() {
      if (whoAmI?.cvpIdp === "AuthSkippedLogin") {
        return "authskippedlogin/logout";
      } else if (whoAmI?.cvpIdp === "Keycloak") {
        return "keycloak/logout";
      } else if (whoAmI?.cvpIdp === "OldSystem") {
        // Impersonation / app one-time-URL login: no external IdP session,
        // so only clear the local cookies.
        return "oldsystem/logout";
      }

      return "logout";
    }

    redirect(`${location.origin}/auth/${getLogoutPath()}?${qs}`, {
      mergeQs: {},
      redirectRaw: true,
    });
  };
};
